const messages = ['Window closed for', 'Window did not load after'];

// Returns true if the Bridge handshake fails due to an error from the app can not recover from.
export const isUnrecoverableError = (error: unknown): boolean =>
	error instanceof Error && messages.some((message) => error.message.startsWith(message));
